import LoadingSpinner from './LoadingSpinner';

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/utils/LoadingSpinner/index.js